// 不想显示nav-bar的黑名单在这里配置。会正则使用这里面的每一项去匹配path.
export default [
  'ktpCourse',
  'ktpMy',
  'ktpInfo',
  'login',
  'courseHome',
  'preLogin',
  'teachingMain',
  'themeInfoDetailPage',
  'teachingAndResearchOffice',
  'TeachingResearchPortalHomepage',
  'teachingResearchRoomSearch',
  'ktpStudentHome',
];
